import { Component, OnInit, Input } from '@angular/core';
import { BasicModalOperationResult, BasicModalBtn } from '../dialog-modal/dialog-modal.component';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-blockchain-sign-modal',
  templateUrl: './blockchain-sign-modal.component.html',
  styleUrls: ['./blockchain-sign-modal.component.scss']
})
export class BlockchainSignModalComponent implements OnInit, IBasicSignModalComponentInstance {
  @Input()
  seedPhrase;

  @Input()
  type: BasicModalOperationResult = BasicModalOperationResult.None;

  @Input()
  title = "Creación de firma electrónica";

  @Input()
  body;

  @Input()
  repeatSign;

  @Input()
  buttons: BasicModalBtn[] = [{
    text: "Aceptar",
    closeModalOnClick: true,
  }];

  constructor(public activeModal: NgbActiveModal) {

  }

  ngOnInit() {
    if (this.repeatSign == null || this.repeatSign == undefined) {
      this.repeatSign = true;
    }
  }

  btnClicked(btnClicked: BasicModalBtn) {
    if (btnClicked.handler) {
      btnClicked.handler(btnClicked);
    }
    if (btnClicked.closeModalOnClick)
      this.activeModal.close(btnClicked.text);
  }

  closeModal() {
    this.activeModal.close();
  }

}

export interface IBasicSignModalComponentInstance {
  title: string;
  body: string;
  seedPhrase: string;
  type: BasicModalOperationResult;
  buttons: BasicModalBtn[];
  repeatSign: boolean;

  closeModal();
}